import request from '@/utils/request'

export function getSalaries() {
  return request({
    url: 'salary/get',
    method: 'post'
  })
}

export function getSalaryDetails(relatedID, type) {
  return request({
    url: 'salary/getDetails',
    method: 'post',
    data: { RelatedId: relatedID, Type: type }
  })
}